import { Directive, TemplateRef, ViewContainerRef, Input } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Directive({
    selector: "[appHideOn]"
})
export class HideOnDirective {
    public isMobile: boolean;

    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private cookieService: CookieService) {}

    /**
     *  How to:
     *
     *  <element *appHideOn="'APP'"></element>
     *  OR
     *  <element *appHideOn="'DESKTOP'"></element>
     *
     */
    @Input() set appHideOn(device: string) {
        this.isMobile = this.cookieService.get("IsMobile") === "1" ? true : false;

        switch (device) {
            case "APP": {
                if (this.isMobile) {
                    this.viewContainer.clear();
                } else {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                }
                break;
            }
            case "DESKTOP": {
                if (this.isMobile) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
                break;
            }
            default: {
                this.viewContainer.createEmbeddedView(this.templateRef);
                break;
            }
        }
    }
}
